import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "-12.056 3.76 14.501 11.24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"-12.056 3.76 14.501 11.24\" id=\"icon-check\">\r\n<path d=\"M-6.771,15c-0.226,0-0.452-0.076-0.639-0.23l-4.285-3.56c-0.425-0.354-0.483-0.983-0.13-1.408\r\n\tc0.354-0.425,0.983-0.483,1.408-0.131l3.541,2.942l7.574-8.517c0.366-0.414,0.998-0.45,1.411-0.083\r\n\tc0.413,0.367,0.45,0.999,0.083,1.412l-8.216,9.239C-6.221,14.887-6.496,15-6.771,15z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol